import React from 'react';
import { TopBarArea } from '../../styles/timeline/gridAreas';
import { TimelineHintLarger } from '../register/InfoBlock';
import { Globe } from 'lucide-react';
import { shortTzName } from '../../utils/timezones';

interface TimelineTopBarProps {
  homeTz?: string;
  browserTz?: string;
  isViewingBrowserTz?: boolean;
  onToggleTz?: () => void;
}

export const TimelineTopBar: React.FC<TimelineTopBarProps> = ({
  homeTz,
  browserTz,
  isViewingBrowserTz = false,
  onToggleTz,
}) => {
  const tzMismatch = homeTz && browserTz && homeTz !== browserTz;
  const alternateTz = isViewingBrowserTz ? homeTz : browserTz;

  return (
    <TopBarArea>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', minWidth: 0 }}>
        <TimelineHintLarger />
        {tzMismatch && (
          <button
            onClick={onToggleTz}
            style={{
              all: 'unset',
              display: 'flex',
              alignItems: 'center',
              gap: '0.35rem',
              padding: '0.35rem 0.75rem',
              borderRadius: '0.5rem',
              fontSize: '0.8rem',
              fontWeight: 500,
              cursor: 'pointer',
              whiteSpace: 'nowrap',
              flexShrink: 0,
              background: 'transparent',
              border: '1px solid var(--colors-sand7, #d4d4d4)',
              color: 'var(--colors-sand12, #1a1a1a)',
              transition: 'background 0.15s',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = 'var(--colors-sand4, #f0f0f0)')}
            onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
          >
            <Globe size={14} />
            <span className="tz-toggle-label">
              View in {shortTzName(alternateTz!)} time
            </span>
          </button>
        )}
      </div>
    </TopBarArea>
  );
};
